import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { NoticeSignUpUrl, NoticeConnectUrl } from '../shared';
import { TalentInfluencerFormValues } from './schema-types';
import { InfluencerAccountSection, InfluencerMemoSection, PostsPriceSection, SocialAccountsSection } from './sections';

export const Template = () => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { isSubmitting }
  } = useFormContext<TalentInfluencerFormValues>();

  const influencerId = watch('id');
  const isEditMode = !!influencerId;

  return (
    <div className="flex gap-6">
      <div className="flex-1">
        <Form.Body className="form-container">
          {isEditMode ? <NoticeConnectUrl /> : <NoticeSignUpUrl />}

          <SocialAccountsSection />
          <InfluencerAccountSection />
          <InfluencerMemoSection />
          <PostsPriceSection />
        </Form.Body>

        <Form.Footer>
          <ButtonSubmit
            title={t('Button.Save')}
            className="ml-auto min-w-36.5"
            loading={{ status: isSubmitting, title: t('Button.Saving') }}
          />
        </Form.Footer>
      </div>
    </div>
  );
};
